import { createSlice } from "@reduxjs/toolkit";

export const StoreSlice = createSlice({
  name: "StoreState",
  initialState: {
    showAddNewItemsNamesModal: false,
    showAddNewItemsModal: false,
    storeItems: [],
    storeItemsInitial: [],
    storeDataLoading: false,
    storeItemAddType: "item", // to manage add items modal to make it handle add new supplier name
  },
  reducers: {
    setStoreItemAddType: (state, action) => {
      state.storeItemAddType = action.payload;
    },
    setStoreDataLoading: (state, action) => {
      state.storeDataLoading = action.payload;
    },
    showAddNewItemsNamesModal: (state, action) => {
      state.storeItemAddType = action.payload;
      state.showAddNewItemsNamesModal = true;
    },
    hideAddNewItemsNamesModal: (state) => {
      state.showAddNewItemsNamesModal = false;
    },
    showAddNewItemsModal: (state) => {
      state.showAddNewItemsModal = true;
    },
    hideAddNewItemsModal: (state) => {
      state.showAddNewItemsModal = false;
    },
    setStoreItems: (state, action) => {
      state.storeItems = action.payload;
    },
    setInitialStoreItems: (state, action) => {
      state.storeItemsInitial = action.payload;
    },
    deleteItem: (state, action) => {
      const { uuid } = action.payload;
      state.storeItems = state.storeItems.filter((item) => item.uiid !== uuid);
    },
  },
});
export const {
  showAddNewItemsNamesModal,
  hideAddNewItemsNamesModal,
  setInitialStoreItems,
  setStoreItems,
  hideAddNewItemsModal,
  showAddNewItemsModal,
  deleteItem,
  setStoreDataLoading,
  setStoreItemAddType,
} = StoreSlice.actions;
export default StoreSlice.reducer;
